function Reports() {
  return (
    <div>
      <h1>Auswertungen</h1>
    </div>
  );
}

export default Reports;
